<template>
  <v-sheet
    class="top-bar d-flex"
    height="58px"
  >
    <div class="w-50" />
    <div class="w-50" />
  </v-sheet>
</template>
